var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashBoardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.03,
    height: 17.444,
    viewBox: "0 0 19.03 17.444",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "pulse",
    d: "M15.065,1H3.964A3.969,3.969,0,0,0,0,4.964v6.343a3.969,3.969,0,0,0,3.964,3.964H8.722v1.586H5.55a.793.793,0,1,0,0,1.586h7.929a.793.793,0,1,0,0-1.586H10.308V15.272h4.757a3.969,3.969,0,0,0,3.964-3.964V4.964A3.969,3.969,0,0,0,15.065,1Zm2.379,10.308a2.379,2.379,0,0,1-2.379,2.379H3.964a2.379,2.379,0,0,1-2.379-2.379V4.964A2.379,2.379,0,0,1,3.964,2.586h11.1a2.379,2.379,0,0,1,2.379,2.379ZM15.858,8.136a.793.793,0,0,1-.793.793H12.714l-1.348,2.026a.793.793,0,0,1-.662.353h-.049a.793.793,0,0,1-.66-.437L8.227,7.334,7.4,8.576a.793.793,0,0,1-.66.353H3.964a.793.793,0,0,1,0-1.586H6.315L7.663,5.317a.783.783,0,0,1,.711-.353.793.793,0,0,1,.66.437L10.8,8.937l.828-1.242a.793.793,0,0,1,.66-.351h2.775A.793.793,0,0,1,15.858,8.136Z",
    transform: "translate(0 -1)",
    fill: "#082654"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashBoardIcon);
export default __webpack_public_path__ + "static/media/dashBoardIcon.5d49fb50179eb5d0f86a4149fe0b9484.svg";
export { ForwardRef as ReactComponent };